@let menuConfigs = menuConfig$ | async;
@let reports = fetchReports$ | async;
@if (reports) {
  <app-apps-menu
    [activeApp]="activeApp"
    [customItemsList]="reports"
    [searchPlaceholder]="'Search for a template or a report kind...'"
    [noResultsText]="'No results found. please try another search term.'"
    (appClick)="openReport($event)"
  ></app-apps-menu>
}
